import { faSmile } from "@fortawesome/free-regular-svg-icons";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, Button, Modal, ModalBody, ModalFooter, ModalHeader, Row, NavLink, Badge, CustomInput } from "reactstrap";
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import { API_TODO_JSON } from "../../../../../constants/APIs";
import { AxiosAPI, getGroupID } from "../../../../../helpers/AxiosAPI";
import Json from "../../../pages/propinfo/json";
function ToDo({ propertyId }) {  
  const [startDate, setStartDate] = useState(moment().subtract(15, 'days').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [json, setJson] = useState('');
  const [id,setId]=useState();
  const togglegallery = (index) => {
    setGalleryVisible(!galleryVisible);
  };
  const [updateModal,setUpdateModal] =useState(false);
  useEffect(()=>{
    loadData();
  },[propertyId]);

  const loadData=()=>{
    try{
      AxiosAPI({
        method: 'get',
        url: `${API_TODO_JSON}?groupId=${getGroupID()}&propertyId=${propertyId}&startDate=${startDate}&endDate=${endDate}`,
      }).then((res) => {      
        let obj=res.data;
        obj=obj.map((m)=>{
          m.isSelected=false;
          return m;
        })
        setToggleData(obj);
      });
    }catch{}
  }

  const handleSubmit=(m)=>{
    AxiosAPI({
      method: 'put',
      url: `${API_TODO_JSON}/update/${m.id}`,
      data : {
        groupId:getGroupID(),
        propertyId:propertyId,
        type:'Customer',
        Note:m.note,
        default:m.default,
        toDo:id,
      }
    }).then((res) => {
      loadData();
      setUpdateModal(false);  
    });
  }

  const [toogleData, setToggleData] = useState([
  ]);
  const selectedImage = (data) => {
    setJson(data);
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image

                </ModalHeader>
                <ModalBody>
                  <Json
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

const handleChange=(index,m)=>{    
  let obj = toogleData;
    if (obj[index].isSelected === true) {
      obj[index].isSelected = false;
    } else {
      obj[index].isSelected = true;
    }
    setId(m);
    setUpdateModal(true);
    setToggleData(obj);
}  
  return (
    <Fragment>
      <div className="row" style={{ height: '50rem', overflowY: 'scroll' }}>
        <div className="col-md-12 mb-4">
          <Card>
            <div style={{ padding: '15px' }}>
              <div className="row mb-3">
                <div className="col-md-6">
                  <div className="d-inline-block">
                    <h2 className="d-inline">
                      To-do List
                    </h2>
                    <span className="text-muted text-small d-block">
                      {/* //Vouchers Interest and Activity */}
                    </span>
                  </div>
                </div>
                <div className="col-md-6 text-right">                
                </div>
              </div>
              {toogleData.length > 0 && toogleData.map((m, index) => {
                if((m.status == "0" || m.status == "Active")&& moment(m.startDate).format('YYYY-MM-DD')<=moment().format('YYYY-MM-DD') &&
                moment(m.endDate).format('YYYY-MM-DD') >=moment().format('YYYY-MM-DD'))
                return (
                  <Fragment>
                    <div className="mb-4" style={{ borderRadius: '5%', boxShadow: ' 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);' }}>
                      <Colxx xxs="12">
                        <Card className="card d-flex mb-3" style={{ borderRadius: '7%', boxShadow: ' 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);' }}>
                          <div className="d-flex flex-grow-1 min-width-zero">
                            <CardBody className="align-self-center flex-column flex-md-row justify-content-between min-width-zero align-items-md-center">
                              <p>  
                              {m.icon !== undefined  && m.icon !== ''?
                                <img width={30} height5 src={"https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885_1280.jpg"}></img>                                 
                                : <i
                                  className={`${'COMPLETED' !== 'COMPLETED'
                                    ? 'simple-icon-check heading-icon'
                                    : 'simple-icon-refresh heading-icon'
                                    }`}
                                />}                              
                                
                                <span className=" ml-2 align-middle d-inline-block">{m.title}</span>
                              </p>
                              <p className="ml-1 mt-2 align-middle d-inline-block mb-1 text-muted text-small w-100 w-xs-100">
                                {m.subTitle}
                              </p>
                              {/* <p className="ml-1 align-middle d-inline-block mb-1 text-muted text-small w-100 w-xs-100">
                                {"item.createDate"}
                              </p> */}
                              <div className="w-15 w-xs-100 mt-2">
                                {/* <Badge color={"item.labelColor"} pill>
                            {"item.label"}
                          </Badge> */}
                                <span className="badge badge-pill badge-primary position-absolute badge ">
                                {m.category}</span>
                              </div>
                            </CardBody>
                            <div className="custom-control custom-checkbox pl-1 align-self-center mr-4">
                              <CustomInput
                                className="itemCheck mb-0"
                                type="checkbox"
                                // id={`check_${item.id}`}                                                       
                                checked={m.isSelected}
                                onChange={(e) => handleChange(index,m)}
                                label=""
                              />
                            </div>
                          </div>
                          <div className="card-body pt-1">
                            <p className="mb-0 ml-2">{m.text}</p>
                          </div>

                         {m.links !== undefined && <div className="card-body pt-3">
                            {m.links.length >0 && <a style={{textDecoration: 'underline',color:'blue' }} href={"#"} onClick={()=>window.location.href=m.links[0].url}><span style={{textDecoration: 'underline',color:'blue' }}>{m.links[0].text}</span> </a>}
                            {m.links.length >1 &&   <a style={{textDecoration: 'underline',color:'blue' }} href={"#"} onClick={()=>window.location.href=m.links[1].url} className="ml-3"><span style={{textDecoration: 'underline',color:'blue' }}>{m.links[1].text}</span> </a>}
                           {m.links.length >2 &&  <a style={{textDecoration: 'underline',color:'blue' }} href={"#"} onClick={()=>window.location.href=m.links[2].url} className="ml-3"><span style={{textDecoration: 'underline',color:'blue' }}>{m.links[2].text}</span> </a>}
                          </div>}
                        </Card>
                      </Colxx>
                    </div>
                  </Fragment>
                );
              })}
            </div>
            <Modal
                isOpen={updateModal}
                toggle={()=>setUpdateModal(!updateModal)}
                style={{ maxWidth: '500px' }}
              >
                <ModalHeader toggle={()=>setUpdateModal(!updateModal)}>
                  To-DO List
                </ModalHeader>
                 <ModalBody>           
                    Are you sure your want to remove this to-do from list ?
                </ModalBody>
                <ModalFooter>
                   <Button color="primary" onClick={()=>handleSubmit(id)}>Submit</Button>
                   <Button className="ml-2" onClick={()=>setUpdateModal(!updateModal)}>Close</Button>
                </ModalFooter>
              </Modal>
            <CardBody>

            </CardBody>
          </Card>
        </div>
      </div>
      {ImageGalleryButton()}
    </Fragment>
  );
}

export default ToDo;